import React from 'react'
import { Link } from 'react-router-dom';
function PricingThree() {
    return (
        <div>
            {/* start pricing area */}
            <div className="rts-pricing-area rts-section-gapBottom">
                <div className="container">
                    <div className="row">
                        <div className="col-12">
                            <div className="rts-title-area pricing-planes text-center">
                                <p className="pre-title">What We Offer</p>
                                <h2 className="title">Packages &amp; Pricing</h2>
                            </div>
                        </div>
                    </div>
                    <div className="row g-5 mt--50">
                        {/* single pricing plane */}
                        <div className="col-xl-4 col-lg-6 col-md-6 col-sm-12 col-12">
                            <div className="pricing-wrapper-one">
                                <div className="plane-process">
                                    <span>/month</span>
                                    <h3 className="title">$260</h3>
                                </div>
                                {/* pricing header */}
                                <div className="pricing-header-start">
                                    <span className="pre-title">Starter Package</span>
                                    <h4 className="title">Basic Plan</h4>
                                </div>
                                {/* pricing header End */}
                                {/* pricing body start */}
                                <div className="pricing-body">
                                    {/* single pricing */}
                                    <div className="single-pricing available">
                                        <div className="icon">
                                            <i className="far fa-check" />
                                        </div>
                                        <span className="price-details">Business Solution</span>
                                    </div>
                                    {/* single pricing End */}
                                    {/* single pricing */}
                                    <div className="single-pricing available">
                                        <div className="icon">
                                            <i className="far fa-check" />
                                        </div>
                                        <span className="price-details">24/7 Consultant Service</span>
                                    </div>
                                    {/* single pricing End */}
                                    {/* single pricing */}
                                    <div className="single-pricing available">
                                        <div className="icon">
                                            <i className="far fa-check" />
                                        </div>
                                        <span className="price-details">Great Customer Support</span>
                                    </div>
                                    {/* single pricing End */}
                                    {/* single pricing */}
                                    <div className="single-pricing ">
                                        <div className="icon">
                                            <i className="far fa-check" />
                                        </div>
                                        <span className="price-details">Market Growth Solution</span>
                                    </div>
                                    {/* single pricing End */}
                                    {/* single pricing */}
                                    <div className="single-pricing">
                                        <div className="icon">
                                            <i className="far fa-check" />
                                        </div>
                                        <span className="price-details">24/7 Consultant Service</span>
                                    </div>
                                    {/* single pricing End */}
                                    <Link className="rts-btn btn-primary" to={'#'}>
                                        Buy This
                                    </Link>
                                </div>
                                {/* pricing body end */}
                            </div>
                        </div>
                        {/* single pricing plane */}
                        {/* single pricing plane */}
                        <div className="col-xl-4 col-lg-6 col-md-6 col-sm-12 col-12 mt_sm--80">
                            <div className="pricing-wrapper-one">
                                <div className="plane-process">
                                    <span>/month</span>
                                    <h3 className="title">$260</h3>
                                </div>
                                {/* pricing header */}
                                <div className="pricing-header-start">
                                    <span className="pre-title">Starter Package</span>
                                    <h4 className="title">Basic Plan</h4>
                                </div>
                                {/* pricing header End */}
                                {/* pricing body start */}
                                <div className="pricing-body">
                                    {/* single pricing */}
                                    <div className="single-pricing available">
                                        <div className="icon">
                                            <i className="far fa-check" />
                                        </div>
                                        <span className="price-details">Business Solution</span>
                                    </div>
                                    {/* single pricing End */}
                                    {/* single pricing */}
                                    <div className="single-pricing available">
                                        <div className="icon">
                                            <i className="far fa-check" />
                                        </div>
                                        <span className="price-details">24/7 Consultant Service</span>
                                    </div>
                                    {/* single pricing End */}
                                    {/* single pricing */}
                                    <div className="single-pricing available">
                                        <div className="icon">
                                            <i className="far fa-check" />
                                        </div>
                                        <span className="price-details">Great Customer Support</span>
                                    </div>
                                    {/* single pricing End */}
                                    {/* single pricing */}
                                    <div className="single-pricing ">
                                        <div className="icon">
                                            <i className="far fa-check" />
                                        </div>
                                        <span className="price-details">Market Growth Solution</span>
                                    </div>
                                    {/* single pricing End */}
                                    {/* single pricing */}
                                    <div className="single-pricing">
                                        <div className="icon">
                                            <i className="far fa-check" />
                                        </div>
                                        <span className="price-details">24/7 Consultant Service</span>
                                    </div>
                                    {/* single pricing End */}
                                    <Link className="rts-btn btn-primary" to={'#'}>
                                        Buy This
                                    </Link>
                                </div>
                                {/* pricing body end */}
                            </div>
                        </div>
                        {/* single pricing plane */}
                        {/* single pricing plane */}
                        <div className="col-xl-4 col-lg-6 col-md-6 col-sm-12 col-12 mt_md--80 mt_sm--80">
                            <div className="pricing-wrapper-one">
                                <div className="plane-process">
                                    <span>/month</span>
                                    <h3 className="title">$260</h3>
                                </div>
                                {/* pricing header */}
                                <div className="pricing-header-start">
                                    <span className="pre-title">Starter Package</span>
                                    <h4 className="title">Basic Plan</h4>
                                </div>
                                {/* pricing header End */}
                                {/* pricing body start */}
                                <div className="pricing-body">
                                    {/* single pricing */}
                                    <div className="single-pricing available">
                                        <div className="icon">
                                            <i className="far fa-check" />
                                        </div>
                                        <span className="price-details">Business Solution</span>
                                    </div>
                                    {/* single pricing End */}
                                    {/* single pricing */}
                                    <div className="single-pricing available">
                                        <div className="icon">
                                            <i className="far fa-check" />
                                        </div>
                                        <span className="price-details">24/7 Consultant Service</span>
                                    </div>
                                    {/* single pricing End */}
                                    {/* single pricing */}
                                    <div className="single-pricing available">
                                        <div className="icon">
                                            <i className="far fa-check" />
                                        </div>
                                        <span className="price-details">Great Customer Support</span>
                                    </div>
                                    {/* single pricing End */}
                                    {/* single pricing */}
                                    <div className="single-pricing ">
                                        <div className="icon">
                                            <i className="far fa-check" />
                                        </div>
                                        <span className="price-details">Market Growth Solution</span>
                                    </div>
                                    {/* single pricing End */}
                                    {/* single pricing */}
                                    <div className="single-pricing">
                                        <div className="icon">
                                            <i className="far fa-check" />
                                        </div>
                                        <span className="price-details">24/7 Consultant Service</span>
                                    </div>
                                    {/* single pricing End */}
                                    <Link className="rts-btn btn-primary" to={'#'}>
                                        Buy This
                                    </Link>
                                </div>
                                {/* pricing body end */}
                            </div>
                        </div>
                        {/* single pricing plane */}
                    </div>
                </div>
            </div>
            {/* end pricing area */}
        </div>
    )
}

export default PricingThree